// @flow
const maxCharLimit = {
  title: 60,
  description: 1000,
};

const defaultMeta = {
  isFavorited: false,
  distribution: {
    none: 0,
    high: 0,
    low: 0,
    medium: 0,
  },
  permissions: [],
};
export {
  maxCharLimit,
  defaultMeta,
};
